import { createAction } from '@reduxjs/toolkit';

import { ColorSlot } from 'js/reducers/brandKitColors';
import { TextStyle } from 'js/reducers/brandKitFonts';
import { OverlayPosition, OverlaySize } from 'js/types';

export interface FontsSnapshot {
  useBrandKitFonts: boolean;
  styles: TextStyle[];
}

export interface OverlaySnapshot {
  position: OverlayPosition;
  opacity: number;
  size: OverlaySize;
  showOverlay: boolean;
}

export interface BrandKitViewLeftPayload {
  colorsBefore: ColorSlot[];
  colorsAfter: ColorSlot[];
  fontsBefore: FontsSnapshot;
  fontsAfter: FontsSnapshot;
  overlayBefore: OverlaySnapshot;
  overlayAfter: OverlaySnapshot;
}

export const trackBrandKitChanges = createAction<BrandKitViewLeftPayload>('BRAND_KIT_VIEW_LEFT');

export const brandKitColorUsed = createAction<{ colorName: string }>('BRAND_KIT_COLOR_USED');
export const brandKitStyleUsed = createAction<{ styleName: string }>('BRAND_KIT_STYLE_USED');
